import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2da22615"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "heading text-center" }
const _hoisted_2 = { class: "mb10 mt10" }
const _hoisted_3 = { class: "sub-heading" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("コース名")
const _hoisted_5 = { class: "error" }
const _hoisted_6 = { class: "form-card" }
const _hoisted_7 = { class: "main" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pl10 color-success" }, "自動生成", -1))
const _hoisted_9 = { class: "error" }
const _hoisted_10 = { class: "error" }
const _hoisted_11 = { class: "right" }
const _hoisted_12 = { class: "sub-heading" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("質問")
const _hoisted_14 = { class: "error" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb20" }, null, -1))
const _hoisted_16 = { class: "sub-heading" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 選択肢 ")
const _hoisted_18 = { class: "color-success" }
const _hoisted_19 = { class: "error" }
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { class: "correct-check" }
const _hoisted_22 = { class: "select-edit" }
const _hoisted_23 = { class: "right" }
const _hoisted_24 = { class: "color-success" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("選択肢追加 ")
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-heading" }, "解説", -1))
const _hoisted_27 = { class: "action" }
const _hoisted_28 = ["id"]
const _hoisted_29 = { class: "color-success" }
const _hoisted_30 = ["id"]
const _hoisted_31 = { class: "color-success" }
const _hoisted_32 = { class: "color-success" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("問題追加 ")
const _hoisted_34 = { class: "text-right" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("保存")

import { ref, computed, nextTick } from "vue";
import { LearningForm } from "@/types/learningForm";
import { faPlus, faTimes, faSortUp, faSortDown } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { LearningCategory } from '@/types/learning_category'
import { QuestionCategory } from '@/types/question_category'
import CategoryListSelect from "@/components/common/categories/CategoryListSelect.vue"
import { Category } from '@/types/category'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import BlotFormatter from 'quill-blot-formatter'
import ImageCompress from 'quill-image-compress'
import MagicUrl from 'quill-magic-url'
interface Props {
  modelValue: string;
  categoryName: string;
  learningForms: LearningForm[];
  learningCategories: LearningCategory[];
  questionCategories: QuestionCategory[];
  formType: string;
  moveCategoryDialogVisible: boolean;
}
interface Emits {
  (e: "addLearningForm"): void;
  (e: "addAnswerFrom", _form: LearningForm): void;
  (e: "removeLearningForm", _key: number): void;
  (e: "removeAnswerForm", _form: LearningForm, _key: number): void;
  (e: "getRandQuestion", _formId: number, _learning_type: string, _category_id: number): void;
  (e: "setQuillRef", _el: any): void;
  (e: "save"): void;
  (e: "syncLearningForm"): void;
  (e: "up", _learning_id: number): void;
  (e: "down", _learning_id: number): void;
  (e: "update:modelValue", value: string): void;
  (e: "update:category", value: LearningCategory): void;
  (e: "update:moveCategoryDialogVisible", visile: boolean): void
}


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: String, required: true },
    categoryName: { type: String, required: true },
    learningForms: { type: Array, required: true },
    learningCategories: { type: Array, required: true },
    questionCategories: { type: Array, required: true },
    formType: { type: String, required: true },
    moveCategoryDialogVisible: { type: Boolean, required: true }
  },
  emits: ["addLearningForm", "addAnswerFrom", "removeLearningForm", "removeAnswerForm", "getRandQuestion", "setQuillRef", "save", "syncLearningForm", "up", "down", "update:modelValue", "update:category", "update:moveCategoryDialogVisible"],
  setup(__props: any, { emit }: { emit: ({
  (e: "addLearningForm"): void;
  (e: "addAnswerFrom", _form: LearningForm): void;
  (e: "removeLearningForm", _key: number): void;
  (e: "removeAnswerForm", _form: LearningForm, _key: number): void;
  (e: "getRandQuestion", _formId: number, _learning_type: string, _category_id: number): void;
  (e: "setQuillRef", _el: any): void;
  (e: "save"): void;
  (e: "syncLearningForm"): void;
  (e: "up", _learning_id: number): void;
  (e: "down", _learning_id: number): void;
  (e: "update:modelValue", value: string): void;
  (e: "update:category", value: LearningCategory): void;
  (e: "update:moveCategoryDialogVisible", visile: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: string;
  categoryName: string;
  learningForms: LearningForm[];
  learningCategories: LearningCategory[];
  questionCategories: QuestionCategory[];
  formType: string;
  moveCategoryDialogVisible: boolean;
}
library.add(faPlus, faTimes, faSortUp, faSortDown);
const modules = [{
  name: 'blotFormatter',
  module: BlotFormatter,
  options: {/* options */ }
},
{
  name: 'MagicUrl',
  module: MagicUrl,
  options: {/* options */ }
},
{
  name: 'ImageCompress',
  module: ImageCompress,
  options: {
    quality: 0.9,
    maxWidth: 1500,
    maxHeight: 1500,
    imageType: 'image/jpeg',
    debug: false,
    suppressErrorLogging: false, // default
  }
}
]
const quillOptions = {
  debug: 'error'
}

// const learning_types =  ref<{[index: number]: string}>({})
const learning_type = ref("similar_select_answer")
const course_error = ref();
const question_error = ref<number[]>([]);
const choice_error = ref<number[]>([]);
const check_correct_error = ref<number[]>([]);
const check_correct_only_error = ref<number[]>([]);

const errorBlank = (() => {
  course_error.value = '';
  question_error.value = [];
  choice_error.value = [];
  check_correct_error.value = [];
  check_correct_only_error.value = [];
})

const courseErrorAdd = () => course_error.value = 'コース名を入力してください'
const questionErrorAdd = ((id: number) => {
  question_error.value.push(id)
})
const choiceErrorAdd = ((id: number) => {
  choice_error.value.push(id)
})
const checkCorrectErrorAdd = ((id: number) => {
  check_correct_error.value.push(id)
})
const checkCorrectOnlyErrorAdd = ((id: number) => {
  check_correct_only_error.value.push(id)
})

const saveDisable = computed(() => {
  errorBlank();
  if (props.learningForms.length == 0) {
    if (props.modelValue.length == 0) {
      courseErrorAdd();
    }
    return true;
  }
  if (props.modelValue.length == 0) {
    courseErrorAdd();
  }
  for (let f of props.learningForms) {
    if (f.question.replace(/<p>|<\/p>|<br>/g, '').length == 0) {
      questionErrorAdd(f.id)
    }
    let check_correct: number = 0;
    for (let answer of f.answers) {
      if (answer.body.replace(/<p>|<\/p>|<br>/g, '').length == 0) {
        choiceErrorAdd(answer.id);
      }
      if (answer.correct) {
        check_correct += 1;
      }
    }
    if (check_correct == 0) {
      checkCorrectErrorAdd(f.id);
    }
    if (f.only_one_select_flg && check_correct > 1) {
      checkCorrectOnlyErrorAdd(f.id);
    }
  }
  if (
    course_error.value.length > 0
    || question_error.value.length > 0
    || choice_error.value.length > 0
    || check_correct_error.value.length > 0
    || check_correct_only_error.value.length > 0) {
    return true
  } else {
    return false
  }
});

const toolber = [
  ['bold', 'italic', 'underline'],
  [{ 'color': [] }, { 'background': [] }],
  ['link'],
  ['image'],
];

const addLearningForm = () => {
  emit("addLearningForm");
};
const addAnswerFrom = (form: LearningForm) => {
  emit("addAnswerFrom", form);
};
const removeLearningForm = (key: number) => {
  emit("removeLearningForm", key);
};
const removeAnswerForm = (form: LearningForm, key: number) => {
  emit("removeAnswerForm", form, key);
};
const getRandQuestion = (formId: number) => {
  emit("getRandQuestion", formId, learning_type.value, category.value.id);
};
const setQuillRef = (el: any) => {
  emit("setQuillRef", el);
}
const up = (learning_id: number) => {
  emit("up", learning_id);
  nextTick(() => {
    let element = document.getElementById('card_' + learning_id);
    if (element) {
      element.scrollIntoView()
    }
  })
}
const down = (learning_id: number) => {
  emit("down", learning_id);
  nextTick(() => {
    let element = document.getElementById('card_' + learning_id);
    if (element) {
      element.scrollIntoView()
    }
  })
}
const save = () => {
  // validate
  emit("save");
};
const syncLearningForm = () => {
  emit('syncLearningForm')
}
// el-inputでvalueやら@changeで渡せないのでcomputedにしてv-modelで渡す用
const courseNameComputed = computed({
  get: () => props.modelValue,
  set: (value) => (emit('update:modelValue', value)),
})
// カテゴリリストから選択されたカテゴリのデフォルト値
let category = ref<Category>({ name: "All", id: -1, children: [], content_count: 0 })


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_fa = _resolveComponent("fa")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, "トレーニングコースの" + _toDisplayString(__props.formType === 'new' ? '作成' : '編集'), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(course_error.value), 1)
        ]),
        _createVNode(_component_el_input, {
          class: "mb20",
          modelValue: _unref(courseNameComputed),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(courseNameComputed) ? (courseNameComputed).value = $event : null)),
          placeholder: "Please input"
        }, null, 8, ["modelValue"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.learningForms, (learningform) => {
        return (_openBlock(), _createElementBlock("div", {
          key: learningform.learning_id
        }, [
          _createVNode(_component_el_card, {
            shadow: "never",
            class: "mb20",
            id: 'card_' + learningform.learning_id
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createVNode(CategoryListSelect, {
                      modelValue: _unref(category),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(category) ? (category).value = $event : category = $event)),
                      categories: __props.questionCategories
                    }, null, 8, ["modelValue", "categories"]),
                    _createVNode(_component_el_select, {
                      modelValue: learning_type.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((learning_type).value = $event)),
                      placeholder: "Select"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: 'QからA',
                          value: 'similar_select_answer'
                        }),
                        _createVNode(_component_el_option, {
                          label: '逆引きQ＆A',
                          value: 'similar_select_question'
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_button, {
                      onClick: ($event: any) => (getRandQuestion(learningform.id)),
                      type: "text"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _withDirectives(_createVNode(_component_el_card, {
                    shadow: "never",
                    class: "errorcheck mt10"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("p", _hoisted_9, "正解の選択肢にチェックを入れてください", 512), [
                        [_vShow, check_correct_error.value.indexOf(learningform.id) !== -1]
                      ]),
                      _withDirectives(_createElementVNode("p", _hoisted_10, " 選択できる解答を1個のみにするにチェックがついていますが複数選択されています", 512), [
                        [_vShow, check_correct_only_error.value.indexOf(learningform.id) !== -1]
                      ])
                    ]),
                    _: 2
                  }, 1536), [
                    [_vShow, check_correct_error.value.indexOf(learningform.id) !== -1 || check_correct_only_error.value.indexOf(learningform.id) !== -1]
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_el_button, {
                      onClick: ($event: any) => (removeLearningForm(learningform.id)),
                      type: "text"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_fa, {
                          class: "color-success",
                          icon: "times"
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  (_openBlock(), _createElementBlock("div", {
                    key: learningform.id
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _withDirectives(_createElementVNode("span", _hoisted_14, "質問を入力してください", 512), [
                        [_vShow, question_error.value.indexOf(learningform.id) !== -1]
                      ])
                    ]),
                    _createVNode(_unref(QuillEditor), {
                      id: 'learning_' + learningform.learning_id,
                      ref: setQuillRef,
                      theme: "snow",
                      toolbar: toolber,
                      content: learningform.question,
                      globalOptions: quillOptions,
                      modules: modules,
                      contentType: 'html',
                      "onUpdate:content": syncLearningForm
                    }, null, 8, ["id", "content"]),
                    _hoisted_15,
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: learningform.only_one_select_flg,
                        "onUpdate:modelValue": ($event: any) => ((learningform.only_one_select_flg) = $event),
                        label: "選択出来る解答を1個のみにする"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(learningform.answers, (answer) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "mb20",
                        key: answer.id
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_16, [
                            _hoisted_17,
                            _createVNode(_component_el_button, {
                              onClick: ($event: any) => (removeAnswerForm(learningform, answer.id)),
                              type: "text"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_18, [
                                  _createVNode(_component_fa, { icon: "times" })
                                ])
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _withDirectives(_createElementVNode("span", _hoisted_19, "選択肢を入力してください", 512), [
                              [_vShow, choice_error.value.indexOf(answer.id) !== -1]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_el_checkbox, {
                              modelValue: answer.correct,
                              "onUpdate:modelValue": ($event: any) => ((answer.correct) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_unref(QuillEditor), {
                              id: 'answer_' + answer.id,
                              ref: setQuillRef,
                              theme: "snow",
                              toolbar: toolber,
                              content: answer.body,
                              globalOptions: quillOptions,
                              modules: modules,
                              contentType: 'html',
                              "onUpdate:content": syncLearningForm
                            }, null, 8, ["id", "content"])
                          ])
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_el_button, {
                        onClick: ($event: any) => (addAnswerFrom(learningform)),
                        type: "text"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_24, [
                            _createVNode(_component_fa, { icon: "plus" }),
                            _hoisted_25
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _hoisted_26,
                    _createVNode(_unref(QuillEditor), {
                      id: 'commentary_' + learningform.learning_id,
                      ref: setQuillRef,
                      theme: "snow",
                      toolbar: toolber,
                      globalOptions: quillOptions,
                      modules: modules,
                      content: learningform.commentary,
                      contentType: 'html'
                    }, null, 8, ["id", "content"])
                  ]))
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      id: 'up_' + learningform.learning_id
                    }, [
                      _createVNode(_component_el_button, {
                        onClick: ($event: any) => (up(learningform.learning_id)),
                        type: "text",
                        class: "up-down-btn"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_29, [
                            _createVNode(_component_fa, { icon: "sort-up" })
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ], 8, _hoisted_28),
                    _createElementVNode("div", {
                      id: 'down_' + learningform.learning_id
                    }, [
                      _createVNode(_component_el_button, {
                        onClick: ($event: any) => (down(learningform.learning_id)),
                        type: "text",
                        class: "up-down-btn"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_31, [
                            _createVNode(_component_fa, { icon: "sort-down" })
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ], 8, _hoisted_30)
                  ])
                ])
              ])
            ]),
            _: 2
          }, 1032, ["id"])
        ]))
      }), 128)),
      _createVNode(_component_el_button, {
        onClick: addLearningForm,
        type: "text"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_32, [
            _createVNode(_component_fa, { icon: "plus" }),
            _hoisted_33
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_34, [
        _createVNode(_component_el_button, {
          class: "mb20",
          disabled: _unref(saveDisable),
          onClick: save,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_35
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _: 1
  }))
}
}

})